import React, { useMemo } from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"
import styles from "../../index.module.css"
import CalendarTimeGrid from "../../CalendarTimeGrid"

/**
 * Week View Component - Data Driven
 * Accepts pre-filtered bookings data as prop
 */
const Week = ({ date, bookingsData = [], journalNoteDates = [], loading = false, onJournalClick }) => {
  const events = useMemo(() => {
    return bookingsData?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.formatted_start_time,
      end: booking?.formatted_end_time,
      title: booking?.title,
      date: booking?.formatted_date,
      payment_status: booking?.payment_status
    }))
  }, [bookingsData])

  return (
    <>
      <CalendarTimeGrid type="week" date={date} events={events} journalNoteDates={journalNoteDates} onJournalClick={onJournalClick} />
      {loading && <Spinner className={styles.spinner} absolute />}
    </>
  )
}

Week.propTypes = {
  date: PropTypes.string.isRequired,
  bookingsData: PropTypes.array,
  journalNoteDates: PropTypes.array,
  loading: PropTypes.bool,
  onJournalClick: PropTypes.func
}

export default Week
